module.exports = __webpack_public_path__ + "static/media/logo.93884c76.png";